export const convertToLocaleTime = (utcDateStr) => {

  if (utcDateStr === "") {
    return null
  }
  let utcDate = new Date(utcDateStr);

  utcDate.setHours(utcDate.getHours() - 8);

  let date = utcDate.toLocaleDateString('en-CA'); // returns date in 'yyyy-MM-dd' format
  let time = utcDate.toLocaleTimeString('en-CA', { hour: '2-digit', minute: '2-digit', hour12: false }); // returns time in 'HH:mm' format

  return `${date} ${time}`; // returns date-time string in 'yyyy-MM-ddTHH:mm' format
};

export const convertToUtcTime = (utcDateStr) => {

  if (utcDateStr === "") {
    return null
  }
  let utcDate = new Date(utcDateStr);

  utcDate.setHours(utcDate.getHours() - 0);

  let date = utcDate.toLocaleDateString('en-CA'); // returns date in 'yyyy-MM-dd' format
  let time = utcDate.toLocaleTimeString('en-CA', { hour: '2-digit', minute: '2-digit', hour12: false }); // returns time in 'HH:mm' format

  return `${date} ${time}`; // returns date-time string in 'yyyy-MM-ddTHH:mm' format
};


export const convertToLocaleTimeSS = (utcDateStr) => {
  if (utcDateStr === "") {
    return null;
  }
  let utcDate = new Date(utcDateStr);
  utcDate.setHours(utcDate.getHours() + 8);
  let dateStr = utcDate.toISOString().slice(0, 19).replace('T', ' ');
  return dateStr ;
};

// export const convertToLocaleTimeSS = (utcDateStr) => {
//   if (utcDateStr === "") {
//     return null;
//   }
//   let utcDate = new Date(utcDateStr);
//   return utcDate.toISOString().slice(0, 19).replace('T', ' ');

//   utcDate.setHours(utcDate.getHours() + 0);

//   let date = utcDate.toLocaleDateString('en-CA'); // returns date in 'yyyy-MM-dd' format
//   let time = utcDate.toLocaleTimeString('en-CA', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }); // returns time in 'HH:mm:ss' format

//   return `${date} ${time}`; // returns date-time string in 'yyyy-MM-ddTHH:mm:ss' format
// };

export const convertToUtcTimeSS = (utcDateStr) => {
  if (utcDateStr === "") {
    return null;
  }
  let utcDate = new Date(utcDateStr);
  // return utcDate.toISOString().slice(0, 19).replace('T', ' ');

  utcDate.setHours(utcDate.getHours() - 8);
  

  let date = utcDate.toLocaleDateString('en-CA'); // returns date in 'yyyy-MM-dd' format
  let time = utcDate.toLocaleTimeString('en-CA', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }); // returns time in 'HH:mm:ss' format

  return `${date} ${time}`; // returns date-time string in 'yyyy-MM-ddTHH:mm:ss' format
};


